import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography, } from '@mui/material';
import CameraswitchIcon from '@mui/icons-material/CameraswitchOutlined';
import Card from '@ui-lib/components/Card';
import qrCodeIcon from '../../../../../../assets/qr-code.svg';

interface Props {
    handleModalStateChange: () => void;
}

const ScanQrCode = ({ handleModalStateChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Card testID='photo-field' >
      <Stack alignItems='center' gap={1}>
        <Box component='img' src={qrCodeIcon} />
        <Typography variant='body2' gutterBottom textAlign='center'>
          {t('scanQrCodeStickerDescription')}
        </Typography>
        <Button
          variant='tonal'
          fullWidth
          onClick={handleModalStateChange}
          startIcon={<CameraswitchIcon />}
        >
          {t('bolCreatePage_scanQrCode')}
        </Button>
      </Stack>
    </Card>
  );
};
  
export default ScanQrCode;